<template>
  <div
    class="lyrics-translate-edit flex height-all"
    :class="{
      [`lyrics-translate-edit--${createRenderType}`]: true,
    }"
  >
    <div
      class="lyrics-translate-edit-item lyrics-translate-edit-item-origin height-all"
    >
      <div class="lyrics-translate-edit-item-label-box">
        <div class="lyrics-translate-edit-item-label flex">
          <span class="block">{{ $$t("editor.original_lyrics") }}</span>
        </div>
      </div>

      <div class="lyrics-translate-edit-item-content">
        <template
          v-for="(item, index) in renderData.lyricsDataArray"
          :key="index"
        >
          <div class="block lyrics-item" v-if="item.type == 'tag'">
            <span
              class="lyrics-item-word"
              :class="{
                'lyrics-item-word-highlight':
                  item.start <= props.currentTime * 1000,
              }"
              >{{ item.text }}</span
            >
          </div>
          <div class="block lyrics-item" v-if="item.type == 'lyrics'">
            <template
              v-for="(itemW, indexW) in item.words"
              :key="`${index}-${index}`"
            >
              <span
                class="lyrics-item-word"
                :class="{
                  'lyrics-item-word-highlight':
                    itemW.start <= props.currentTime * 1000,
                }"
                >{{ itemW.text }}</span
              >
            </template>
          </div>
        </template>
      </div>
    </div>
    <div
      class="lyrics-translate-edit-item lyrics-translate-edit-item-translated height-all"
    >
      <div class="lyrics-translate-edit-item-label-box">
        <div class="lyrics-translate-edit-item-label flex">
          <span class="block">{{ $$t("editor.translated_lyrics") }}</span>
          <el-tooltip
            popper-class="lyrics-translate-edit-question-popper"
            :content="$$t('editor.translates_lyrics_question')"
            placement="top"
            :popperOptions="{
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    offset: [0, 4],
                  },
                },
              ],
            }"
          >
            <i class="block"> </i>
          </el-tooltip>
        </div>
        <div class="lyrics-translate-edit-item-label-btn">
          <IconButton
            size="30px"
            icoSize="18px"
            :loading="props.disabled"
            @onClick="onReTranslatedClick"
            backgroundColor="rgba(255, 255, 255, 0)"
            hoverBackgroundColor="rgba(255, 255, 255, 0.1)"
          >
            <img src="@/assets/img/editor/icon-translate.png" />
          </IconButton>
        </div>
      </div>
      <div class="lyrics-translate-edit-item-content">
        <template
          v-for="(item, index) in renderData.lyricsDataArray"
          :key="index"
        >
          <div class="block lyrics-item" v-if="item.type == 'tag'">
            <span
              class="lyrics-item-word"
              :class="{
                'lyrics-item-word-highlight':
                  item.start <= props.currentTime * 1000,
              }"
              >{{ item.text }}</span
            >
          </div>
          <div
            class="block lyrics-item"
            v-if="item.type == 'lyrics' && item.translatedText != null"
          >
            <div
              class="lyrics-item-translate-text"
              v-if="renderData.currentEditIndex != index || props.disabled"
              @click.stop="onEditClick(item, index)"
            >
              <template
                v-for="(itemW, indexW) in item.translatedwords"
                :key="`${index}-${index}`"
              >
                <span
                  class="lyrics-item-word"
                  :class="{
                    'lyrics-item-word-highlight':
                      itemW.start <= props.currentTime * 1000,
                  }"
                  >{{ itemW.text }}</span
                >
              </template>
            </div>

            <div
              class="lyrics-item-translate-input-box"
              v-if="renderData.currentEditIndex == index && !props.disabled"
              @click.stop
            >
              <textarea
                :ref="
                  (el) => {
                    refInput = el;
                  }
                "
                type="text"
                v-model="item.translatedText"
                class="lyrics-item-translate-input"
                placeholder="Please enter the translation"
                @blur.native="
                  (e) => {
                    onEditBlur(item, index);
                  }
                "
                @input.native="
                  (e) => {
                    onEditInput(item, index, e);
                  }
                "
                @compositionstart="
                  (e) => {
                    handleCompositionStart(item, index, e);
                  }
                "
                @compositionend="
                  (e) => {
                    handleCompositionEnd(item, index, e);
                  }
                "
                @click.stop
              />
              <div
                class="lyrics-item-translate-input-count"
                :class="{
                  'color-red':
                    item.translatedText?.length >=
                    Math.ceil(item.translatedSourceText?.length * 1.15),
                }"
              >
                {{
                  `${item.translatedText?.length} / ${Math.ceil(
                    item.translatedSourceText?.length * 1.15
                  )}`
                }}
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
  getCurrentInstance,
} from "vue";

import { useRouter, useRoute } from "vue-router";

import Bubble from "@/components/bubble/bubble.vue";
import IconButton from "@/components/basic/button/IconButton.vue";

import { storeToRefs } from "pinia";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";

const createLayoutStore = useCreateLayoutStore();
const { createRenderType } = storeToRefs(createLayoutStore);
const Router = useRouter();
const route = useRoute();
const { $$language, $$t, $$tm, $$tValue } = getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {}

const globalProperties =
  getCurrentInstance()?.appContext.config.globalProperties;
const props = defineProps({
  lyrics: {
    type: Array,
    default: () => [],
  },
  currentTime: {
    type: Number,
    default: 0,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  translatedLyrics: {
    type: Array,
    default: () => [],
  },
});

const refInput = ref(null);

const emits = defineEmits(["reTranslated"]);

const renderData = reactive({
  inputing: false,
  lyricsDataArray: [
    { text: "阳光灿烂，" },
    {
      text: "天空是蓝色的",
    },
    {
      text: "眼前一片云也没有，",
    },
    {
      text: "这是一个完美的风景",
    },
    {
      text: "鸟儿在歌唱，",
    },
    {
      text: "花儿盛开了花儿盛开了花儿盛开了花儿盛开了。",
    },
    {
      text: "我的心在飞翔，",
    },
    {
      text: "我的精神在飞速发展",
    },
    {
      text: "我感到脸上的温暖",
    },
    {
      text: "它让我充满了喜悦的优雅",
    },
    {
      text: "世界闪闪发光，",
    },
    {
      text: "一切都如此明亮",
    },
    {
      text: "我充满了纯粹的喜悦",
    },
    {
      text: "阳光照在我的肩膀上，使我快乐",
    },
    {
      text: "我眼中的阳光不会让我哭泣",
    },
    {
      text: "阳光照在水面上看起来很可爱",
    },
    {
      text: "阳光总是让我兴奋",
    },
  ],
});

const onReTranslatedClick = () => {
  renderData.currentEditIndex = -1;
  emits("reTranslated");
};

const getTranslatedWords = (text, start, end) => {
  if (!text) return [];
  console.log(text, start, end);
  const textWords = text.split(" ");
  const textLength = textWords.length;
  const timeStep = (end - start) / textLength;
  return textWords.map((word, index) => {
    return {
      text: index == textWords.length - 1 ? word : word + " ",
      start: start + timeStep * index,
      end: Math.min(start + timeStep * index + timeStep, end),
    };
  });
};

const generateLyricRenderData = (lyrics, translatedLyrics) => {
  return lyrics.reduce((res, item, index) => {
    if (item.user_input_tag) {
      res.push({
        start: item.start,
        end: item.end,
        text: item.user_input_tag,
        type: "tag",
        space: "",
        break: "\n",
        transLateText:
          translatedLyrics[index].user_input_tag ?? item.user_input_tag,
      });
    }
    if (item.rows?.length) {
      res.push(
        ...item.rows.reduce((resR, row, rIndex) => {
          if (row.text?.length) {
            resR.push({
              ...row,
              type: "lyrics",
              words: row.words,
              space: "",
              break: "\n",
              translatedSourceText:
                translatedLyrics[index].rows[rIndex]?.text ?? [],
              translatedText: translatedLyrics[index].rows[rIndex].text ?? null,
              translatedwords:
                translatedLyrics[index].rows[rIndex]?.words ??
                getTranslatedWords(
                  translatedLyrics[index].rows[rIndex].text,
                  row.start,
                  row.end
                ),
            });
          }
          return resR;
        }, [])
      );
    }
    return res;
  }, []);
};

const initLyricData = () => {
  renderData.lyricsDataArray = generateLyricRenderData(
    props.lyrics,
    props.translatedLyrics
  );
};

const onEditClick = (item, index) => {
  renderData.currentEditIndex = index;
  nextTick(() => {
    refInput.value?.focus();
  });

  globalProperties.logCustomEvent("lyrics_translate_button_click", {
    tab_stare: "lyrics_editing",
  });
};

const onClikOutSide = () => {
  renderData.currentEditIndex = -1;
};

const onEditBlur = (item, index) => {
  let start = item.start;
  let end = item.end;
  let text = item.translatedText;
  if (text.length >= Math.floor(item.translatedSourceText.length / 2)) {
    const textWords = text.split(" ");
    const textLength = text.length;
    const timeStep = (end - start) / textLength;
    item.translatedwords = textWords.map((word, index) => {
      return {
        text: index == textWords.length - 1 ? word : word + " ",
        start: start + timeStep * index,
        end: Math.min(start + timeStep * index + timeStep, end),
      };
    });
  } else {
    text = item.translatedSourceText;
    const textWords = text.split(" ");
    const textLength = text.length;
    const timeStep = (end - start) / textLength;
    item.translatedText = text;
    item.translatedwords = textWords.map((word, index) => {
      return {
        text: index == textWords.length - 1 ? word : word + " ",
        start: start + timeStep * index,
        end: Math.min(start + timeStep * index + timeStep, end),
      };
    });
  }
};

const handleCompositionStart = (item, index) => {
  renderData.inputing = true;
};

const handleCompositionEnd = (item, index, e) => {
  renderData.inputing = false;
  onEditInput(item, index, e);
};

const onEditInput = (item, index, e) => {
  if (!renderData.inputing) {
    const text = item.translatedText;
    const maxLength = Math.ceil(item.translatedSourceText.length * 1.15);
    if (text.length > maxLength) {
      item.translatedText = text.slice(0, maxLength);
    }
  }
};

watch(
  () => {
    return props.lyrics;
  },
  () => {
    initLyricData();
  }
);

watch(
  () => {
    return props.currentTime;
  },
  () => {
    console.log("🍎🍎🍎🍎props.currentTime", props.currentTime);
  }
);

onMounted(() => {
  initLyricData();
  document.addEventListener("click", onClikOutSide);
});

onBeforeUnmount(() => {
  document.removeEventListener("click", onClikOutSide);
})

defineExpose({
  setLyricsData: (lyricsDataArray) => {
    renderData.lyricsDataArray = lyricsDataArray;
  },
  getLyricsData: () => {
    return renderData.lyricsDataArray;
  },
  getTranslatedLyrics: () => {
    renderData.currentEditIndex = -1;
    return [
      {
        rows: renderData.lyricsDataArray.reduce((res, row, index) => {
          if (row.type == "lyrics" && row.translatedText) {
            res.push({
              start: row.start,
              end: row.end,
              text: row.translatedText,
            });
          }
          return res;
        }, []),
      },
    ];
  },
  getLyrics: () => {
    return renderData.lyricsDataArray
      .reduce((res, row, index) => {
        if (row.type == "lyrics" && row.translatedText) {
          res += row.translatedText;
          res += row.break;
        } else if (row.type == "tag") {
          res += row.text;
          res += row.break;
        } else {
        }
        return res;
      }, "")
      .replace(/\n$/, "");
  },
});
</script>
<style lang="scss">
.lyrics-translate-edit {
  .lyrics-translate-edit-item {
    width: 50%;
    display: flex;
    flex-direction: column;
  }
  .lyrics-translate-edit-item-content {
    height: 0;
    flex: 1;
    overflow-y: auto;
  }
  .lyrics-translate-edit-item-label-box {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px 0 20px;
    .lyrics-translate-edit-item-label-btn {
      margin: 6px 0 0 0;
    }
  }
  .lyrics-translate-edit-item-label {
    width: 138px;
    height: 28px;
    min-height: 28px;
    border-radius: 0px 0px 8px 8px;
    flex-direction: column;
    justify-content: center;
    background: rgba(255, 255, 255, 0.2);
    margin: 0 0 8px 0;
    font-family: HarmonyOS Sans SC;
    font-size: 12px;
    color: #ffffff;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    i {
      height: 14px;
      width: 14px;
      margin: 0 0 0 4px;
      background: url(@/assets/img/circle-question-ico.png);
      background-size: 100% 100%;
    }
  }
  .lyrics-translate-edit-item-origin {
    .lyrics-item {
      padding: 0 10px 0 20px;
    }
  }

  .lyrics-translate-edit-item-translated {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 0px 0px 16px 0;
  }

  .lyrics-translate-edit-item-content {
    padding: 0 0;
    font-family: HarmonyOS Sans SC;
    font-size: 16px;
    font-weight: normal;
    line-height: 28px;
    letter-spacing: 0em;
    color: rgba(255, 255, 255, 0.5);
    .lyrics-item-word-highlight {
      color: #72ffec;
    }
  }
  .lyrics-item-translate-text {
    padding: 0 10px 0 20px;
  }
  .lyrics-item-translate-input-box {
    min-height: 28px;
    background: #6462e4;
    display: flex;
    align-items: center;
    margin: 0 0 0 20px;
    position: relative;
    textarea {
      background: transparent;
      border: none;
      outline: none;
      width: 0;
      flex: 1;
      height: 100%;
      font-family: HarmonyOS Sans SC;
      font-size: 16px;
      font-weight: normal;
      line-height: 28px;
      letter-spacing: 0em;
      color: rgba(255, 255, 255, 1);
      resize: none;
      height: max-content;
      padding: 0 50px 0 0px;
      &::placeholder {
        color: rgba(255, 255, 255, 0.5) !important;
      }
    }
    .lyrics-item-translate-input-count {
      font-family: HarmonyOS Sans SC;
      font-size: 10px;
      font-weight: normal;
      color: rgba(255, 255, 255, 0.5);
      pointer-events: none;
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      &.color-red {
        color: #ff5f74;
      }
    }
  }
  .lyrics-translate-edit-item-translated {
    .lyrics-translate-edit-item-content {
      color: rgba(255, 255, 255, 1);
    }
  }

  &.lyrics-translate-edit--mobile {
    .lyrics-translate-edit-item-label-box {
      padding: 0 10px 0 16px;
    }
    .lyrics-translate-edit-item-label {
      margin: 0 0 8px 0;
    }
    .lyrics-translate-edit-item-origin {
      display: none;
    }

    .lyrics-translate-edit-item-translated {
      width: 100%;
      .lyrics-item-translate-text {
        padding: 0 16px 0 16px;
      }
      .lyrics-item-translate-input-box {
        margin: 0 16px;
      }
      .lyrics-item-translate-input-count {
        right: 0;
      }
    }
  }
}
.el-popper.is-dark.lyrics-translate-edit-question-popper {
  width: 210px;
  padding: 12px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.5) !important;
  backdrop-filter: blur(30px);
  font-family: HarmonyOS Sans SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 18px;
  color: #ffffff;
}
</style>
